import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent, trackEvent } from "@/lib/tracking";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!getConsent()) {
            const t = setTimeout(() => setVisible(true), 1400);
            return () => clearTimeout(t);
        }
    }, []);

    const decide = (value) => {
        setConsent(value);
        window.dispatchEvent(new Event("cbz:consent-change"));
        trackEvent("cookie_consent", { choice: value });
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                    data-testid="banner-cookie-consent"
                    role="dialog"
                    aria-label="Aviso de cookies e privacidade"
                    className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-2xl border border-[#08104F]/10 bg-[#FFFDFA]/95 p-5 shadow-[0_20px_60px_rgba(8,16,79,0.25)] backdrop-blur-xl sm:inset-x-auto sm:right-24 sm:bottom-6 sm:w-[26rem]"
                >
                    <p className="text-sm font-semibold text-[#08104F]">Privacidade em primeiro lugar</p>
                    <p className="mt-1.5 text-xs leading-relaxed text-[#3A4768]">
                        Usamos cookies para melhorar sua experiência e medir resultados, sempre em conformidade
                        com a LGPD. Saiba mais na nossa{" "}
                        <Link to="/politica-de-privacidade" className="font-medium text-[#0047BB] underline">
                            Política de Privacidade
                        </Link>
                        .
                    </p>
                    <div className="mt-4 flex gap-2.5">
                        <button
                            type="button"
                            data-testid="btn-cookie-accept-all"
                            onClick={() => decide("accepted")}
                            className="flex-1 rounded-full bg-[#08104F] px-4 py-2.5 text-xs font-semibold text-white transition-colors duration-200 hover:bg-[#0047BB] active:scale-[0.98]"
                        >
                            Aceitar todos
                        </button>
                        <button
                            type="button"
                            data-testid="btn-cookie-reject"
                            onClick={() => decide("rejected")}
                            className="flex-1 rounded-full border border-[#08104F]/20 px-4 py-2.5 text-xs font-semibold text-[#08104F] transition-colors duration-200 hover:bg-[#08104F]/5 active:scale-[0.98]"
                        >
                            Apenas essenciais
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
